const Tooltip = (props) => (
  <span className='tooltip-container'>
    <span className={`tooltip-trigger ${props.qaClasses || ''}`}>
      {props.trigger}
    </span>
    <span className={`tooltip-message ${props.customClasses || ''}`}>
      {props.tooltipMessage}
    </span>
  </span>
)

export default Tooltip
